import axios from 'axios';
import {
	Loading
} from 'element-ui';
// import qs from 'qs';
import router from './router';
import {
	Message
} from 'element-ui';
import { List } from 'echarts';
// import store from './store';
// axios.defaults.baseURL = '/test/sys' //本地调试线
//前端的配置需要修改vue.config.js   默认线上测试
//环境配置  1：发版
const isVue =1
let filePath = ''
let isTokenNO=false
if (isVue == 1) {
	const basePath = window.location.pathname.startsWith('/test') ? '/test/sys' : '/sys';
	filePath = window.location.origin + basePath;
} else if (isVue == 2) {
	filePath = "/api/sys" //本地连接线上测试调试
} else if (isVue == 3) {
	filePath = "/sys" //正式发版/本地连接线上调试
} else if (isVue == 4) {
	filePath = "/v1/api/sys" //本地后端测试
} else if (isVue == 5) {
	filePath = "/v1/sys" //本地后端正式
}

// 
// 公有方法
const fileurl = {
	postLogin: filePath + '/login', //统一登陆接口
	getUserInfoLogin: filePath + '/teacher/userInfo', //双端登陆
	postLogout: filePath + '/logout', //退出登陆	
	postLoginQr: filePath + '/login-by-qr', //统一登陆接口
	getAuthList: filePath + '/authP/list/', //绑定手机号码用户列表
	postSendCaptcha: filePath + '/authP/sendCaptcha', //发送验证码，直接调用3分钟有效
	postCaptchaPwd: filePath + '/authP/captchaPwd', //验证码修改手机登陆密码 captcha  newPwd
	postPhoneUpdatePwd: filePath + '/authP/updatePwd', //手机登陆密码修改
	postAuthSwitchUser: filePath + '/authP/switch-user', //切换用户
	getUploadParam: filePath + '/oss/getUploadParam', //获取oss临时上传密钥
	getStsCredential: filePath + '/oss/getStsCredential', //获取oss临时下载密钥
	getCustomHtmlUploadParam: filePath + '/oss/getCustomHtmlUploadParam', //html获取oss临时上传密钥
	getModelUploadParam: filePath + '/oss/getModelUploadParam', //html获取模型图片临时上传密钥
	getImgToOss: filePath + '/oss/getImgToOss', //富文本编辑器上传图片
	
	getLanPeers: filePath + '/lan/peers',
	postLanPeers: filePath + '/lan/report',
	postAssignPush: filePath + '/lan/assignPush',
	postCancelPush: filePath + '/lan/cancelPush',
	getUserMenuTree: filePath + '/role/menu/userMenuTree',//platform=2&userId=4&orgId=6
	//共有的敏感词库
	getAllWords:filePath + '/ai/monitor/word/getAllWords', //敏感词数组
	getMonitorWorkList: filePath + '/ai/monitor/word/list', //敏感词列表
	postMonitorWorkAdd: filePath + '/ai/monitor/word/add', //单个添加敏感词
	postMonitorWorkBatchAdd: filePath + '/ai/monitor/word/batchAdd', //批量添加敏感词
	deletedMonitorWorkBatchDelete: filePath + '/ai/monitor/word/batchDelete', //批量删除敏感词
	putMonitorUpdate: filePath + '/ai/monitor/word/update', //修改敏感词
	deletedMonitorWorkDelete: filePath + '/ai/monitor/word/delete/', //单个删除敏感词
	//公有的消耗统计--旧
	getschoolTokenSingle: filePath + '/stat/schoolToken/single', //学校按场景统计
	getschoolTokenTime: filePath + '/stat/schoolToken/timeToken', //学校学期内时间戳
	getschoolTokenGradeTime: filePath + '/stat/schoolToken/grade/token/group', //学校学期年级
	getschoolTokenSubject: filePath + '/stat/schoolToken/subject/all', //学校学期学科
	// getschoolTokenClass: filePath + '/stat/schoolToken/class/all', //学校学期班级
	// getschoolTokenStudent: filePath + '/stat/schoolToken/student/all', //学校学期班级
	//统计token消耗今日之前
	getStudentDateMessage: filePath + '/date/studentMessage/student/list', //学生统计
	getClassDateMessage: filePath + '/date/studentMessage/class/list', //班级统计
	getSubjectDateMessage: filePath + '/date/studentMessage/subject/list', //学科统计
	getGradeDateMessage: filePath + '/date/studentMessage/grade/list', //年级统计
	
	//html文件管理
	postHtmlSave: filePath + '/html/uploadRecord/save', //保存html
	getDetail: filePath + '/html/uploadRecord/getDetail', //查询有
	//html分层规则接口
	postHtmlStratifiedSync: filePath + '/html/stratified/rules/sync', //保存html分层规则
	getHtmlStratifiedList: filePath + '/html/stratified/rules/listByRecordId', //查询html有效规则列表
	getHtmlStratifiedId: filePath + '/html/stratified/rules/get/', //分层id查询规则信息
	//学校标准类型资源oss接口
	getOrgIdLogin: filePath + '/oss/getOrgIdLogin', //上传学校标准资源
	//
	getStudentImportTemplate: filePath + '/excel/studentImportTemplate', //下载年级导入学生的表格
	
	//扣子公有查询逻辑方法
	getCozeBenefit: filePath + '/coze/benefit', //查询账号权益
	getCozeWorkspaces: filePath + '/coze/workspaces', //查询账号权益
	getCozeBotList: filePath + '/coze/botList', //获取扣子智能体列表
	getCozeBotVersionsList: filePath + '/coze/botVersionsList', //获取扣子智能体版本列表
	getCozeBotLatest:filePath + '/coze/botLatest', //获取扣子智能体发布最新参数
	getCozeWorkflowList:filePath + '/coze/workflowList', //获取扣子工作流列表
	getCozeWorkflowVersionsList: filePath + '/coze/workflowVersionsList', //获取扣子工作流版本列表
	getCozeWorkflowsLatest: filePath + '/coze/workflowsLatest', //获取扣子工作流配置参数
	//返回火山引擎的模型列表
	
	getSyncFoundationModel: filePath + '/volc/syncFoundationModel', //同步火山模型
	getVolcListSimple: filePath + '/volc/list/simple', //获取所有火山未下线的模型列表，公开模型
	getVolcListSimplePage: filePath + '/volc/list/simple/page', //获取所有火山未下线的模型列表分页
	getVolcId: filePath + '/volc/', //id返回信息
	postVolcResponses: filePath + '/volc/chat/responses', //模拟请求判断
	//千问百炼
	getModelModelPermissions: filePath + '/dashscope/model/modelPermissions', //判断密钥及模型问题
	getModelModelList: filePath + '/dashscope/model/status/page', //有效的模型列表
	getModelModelId: filePath + '/dashscope/', //根据id返回信息
	getDashscopeSimList: filePath + '/dashscope/model/simList', //返回所有的id和name
	
	//deepseek
	postDeepseekList: filePath + '/DeepSeekModel/list', //返回用户名下的模型列表
	
	
	//发布信息管理
	postNoticeDocSave: filePath + '/admin/noticeDoc/save', //保存信息
	postNoticeDocUpdate: filePath + '/admin/noticeDoc/update', //更新信息
	postNoticeDocStatus: filePath + '/admin/noticeDoc/update/status', //修改状态
	
	getNoticeDocAdminPage: filePath + '/admin/noticeDoc/admin/page', //获取后台信息列表
	getNoticeDocContent: filePath + '/admin/noticeDoc/get/content/', //通过id获取信息内容
	getNoticeFrontList: filePath + '/admin/noticeDoc/front/list/', //通过类型已经发布的
	
	
	
	

	
}
//中台
const admin = {
	postSyncChina: filePath + '/sysRegion/syncChina', //同步高德地图
	getRegionList: filePath + '/sysRegion/list', //高德地图列表

	PutAdminPwd: filePath + '/admin/updatePwd', //修改中台用户密码
	PutAdminText: filePath + '/admin/update', //修改中台用户信息
	getUserList: filePath + '/admin/list', //查询中台用户
	deleteUserRemove: filePath + '/admin/remove/', //删除中台用户
	addAdminUser: filePath + '/admin/add', //新增中台用户
	postSchoolUserBindPhone: filePath + '/admin/bindPhone', //绑定手机号码
	//教育局--中台管理
	postEduAdd: filePath + '/edu/add', //新增教育局
	getEduList: filePath + '/edu/list', //查询教育局列表
	putEduUpdate: filePath + '/edu/update', //修改教育局
	getRemoteSearch: filePath + '/edu/remoteSearch', //修改教育局
	getEduId: filePath + '/edu/get/', //查询教育局
	//学校--中台管理
	postSchoolAdd: filePath + '/school/add', //新增学校
	getSchoolList: filePath + '/school/list', //学校列表
	putSchoolUpdate: filePath + '/school/update', //新增学校
	putSchoolUpdateLogin: filePath + '/school/updateLogin', //更新学校部分信息
	
	//ai
	getModelTypeList: filePath + '/ai/modelType/list', //模型类型列表
	postModelTypeAdd: filePath + '/ai/modelType/add', //增加模型类型
	putModelTypeUpdate: filePath + '/ai/modelType/update', //修改模型类型
	putModelTypeStatus: filePath + '/ai/modelType/status/', //修改模型类型状态
	putModelTypeRemove: filePath + '/ai/modelType/remove/', //删除模型类型
	getModelKeyList: filePath + '/ai/modelKey/list', //查询密钥列表
	
	postModelKeyAdd: filePath + '/ai/modelKey/add', //增加密钥类型
	putModelKeyUpdate: filePath + '/ai/modelKey/update', //修改密钥
	getModelKeyArr: filePath + '/ai/modelKey/get/', //查询信息
	
	getModelKeySimple: filePath + '/ai/modelKey/simple', //查询密钥列表基础信息
	getModelWithoutKey: filePath + '/ai/modelKey/get/without-key/', //查询密钥列表
	putUpdateKeyOnly: filePath + '/ai/modelKey/update-key-only', //修改密钥
	postModelKeySetShare: filePath + '/ai/modelKey/setShare', //设置是否共享
	getModelKeyMyShareList: filePath + '/ai/modelKey/myShareList', //我共享的
	getModelKeyOrgShareList: filePath + '/ai/modelKey/orgShareList', //机构内共享的
	putModelKeyStatus: filePath + '/ai/modelKey/status/', //修改模型类型
	deleteModelKeyRemove: filePath + '/ai/modelKey/remove/', //修改模型类型
	
	//标准工作流或者智能体
	postStandardAdd: filePath + '/ai/standard/course/add', //增加智能体/工作流
	putStandardUpdate: filePath + '/ai/standard/course/update', //修改智能体/工作流
	putStandardStatus: filePath + '/ai/standard/course/status/', //修改智能体/工作流状态
	deleteStandardRemove: filePath + '/ai/standard/course/remove', //修改智能体/工作流
	getStandardList: filePath + '/ai/standard/course/list', //修改课程
	//标准模型
	getStandardModelList:filePath + '/ai/standard/model/list',
	getStandardModelAgentList:filePath + '/ai/standard/model/agentList',//智能体广场列表
	getStandardModelSimple:filePath + '/ai/standard/model/simple',
	getStandardModelId:filePath + '/ai/standard/model/get/',//根据id查询信息
	
	postStandardModelAdd: filePath + '/ai/standard/model/add', //增加标准模型
	putStandardModelUpdate: filePath + '/ai/standard/model/update', //修改标准模型
	putStandardModelStatus: filePath + '/ai/standard/model/status', //修改标准模型状态
	deleteStandardModelRemove: filePath + '/ai/standard/model/remove', //删除标准模型软
	//模型图
	postModelResourceAdd: filePath + '/ai/model/resource/add', //模型图片资源
	



	//结束
   
	postWorkflowAdd: filePath + '/ai/workflow/add', //增加智能体/工作流
	putWorkflowUpdate: filePath + '/ai/workflow/update', //修改智能体/工作流
	putWorkflowStatus: filePath + '/ai/workflow/status', //修改智能体/工作流状态
	getWorkflowList: filePath + '/ai/workflow/list', //授权列表
	deleteWorkflowRemove: filePath + '/ai/workflow/remove', //修改智能体/工作流
	postCourseAdd: filePath + '/ai/course/add', //新增课程
	putCourseUpdate: filePath + '/ai/course/update', //修改课程
	getCourseList: filePath + '/ai/course/list', //修改课程
	getStandardAllList: filePath + '/ai/course/allList', //修改课程
	putCourseStatus: filePath + '/ai/course/status/', //修改状态
	deletedCourseRemove: filePath + '/ai/course/remove/', //删除
	//保存config参数
	putCourseConfig: filePath + '/ai/course/config/', //修改课程config
	getCourseConfig: filePath + '/ai/course/config/', //查询课程config
	//菜单
	postMenuAdd: filePath + '/menu/add',
	postMenuUpdate: filePath + '/menu/update',
	getMenuDelete: filePath + '/menu/delete',
	getMenuTree: filePath + '/menu/tree',

	// 按钮
	postButtonAdd: filePath + '/button/add',
	postButtonBind: filePath + '/button/bind',
	getButtonGetByMenu: filePath + '/button/getByMenu',
	getButtonList: filePath + '/button/list',
	getButtonDelete: filePath + '/button/delete',
	postButtonUpdate: filePath + '/button/update',


	// 角色
	getRoleList: filePath + '/role/listByPlatform',
	postRoleAdd: filePath + '/role/add',
	postRoleUpdate: filePath + '/role/update',
	getRoleDelete: filePath + '/role/delete',

	// 角色授权
	getRoleMenuCodes: filePath + '/role/menu/getRoleMenuCodes',
	postRoleMenuAuth: filePath + '/role/menu/auth',

	// 业务授权
	postBusinessAuth: filePath + '/business/menu/auth',
	getBusinessList: filePath + '/business/menu/list',
	postBusinessDelete: filePath + '/business/menu/delete',
	
	getMenuBusinessList: filePath + '/business/menu/businessList',
	//学科
	getAdminSubjectList: filePath + '/adminSubject/list',
	postAdminSubjectAdd: filePath + '/adminSubject/add',
	postAdminSubjectUpdate: filePath + '/adminSubject/update',
	getAdminSubjectStatus: filePath + '/adminSubject/status/',
	
	//基础学期
	getAdminSemesterList: filePath + '/admin/semester/list',
	postAdminSemesterAdd: filePath + '/admin/semester/add',
	putAdminSemesterUpdate: filePath + '/admin/semester/update',
	
	getAdminSemesterStatus: filePath + '/admin/semester/status/',
	getAdminSemesterDefaultCreate: filePath + '/admin/semester/defaultCreate/',
	getAdminSemesterBatchSync: filePath + '/admin/semester/batchSync/',//同步给学校学期
	
	//学校学期
	getSchoolListWithSemester: filePath + '/school/semester/schoolListWithSemester',//获取学校学期列表
	getSchoolSemesterList: filePath + '/school/semester/list',//获取某一个学校
	postSchoolSemesterUpdate: filePath + '/school/semester/update',
	
	//学校学科
	getschoolListWithSubject: filePath + '/school/subject/schoolListWithSubject',//学科学校列表
	getschoolSubjectList: filePath + '/school/subject/list',//学科学校列表
	postschoolSubjectAdd: filePath + '/school/subject/add',//学科学校增加
	
	//日志
	getLogPage: filePath + '/admin/api/log/page',//日志
	getLogDetail: filePath + '/admin/api/log/detail',//明细
	
	//基础信息
	getBasicList: filePath + '/admin/basic/list',//基础信息分页列表
	getBasicListAll: filePath + '/admin/basic/listAll',//基础信息不分页
	getBasicListId: filePath + '/admin/basic/',//通过id查询
	getBasicListCode: filePath + '/admin/basic/code/',//通过code查询
	postBasicAdd: filePath + '/admin/basic/add',//新增基础配置
	putBasicUpdate: filePath + '/admin/basic/update',//修改基础配置
	deletedBasicId: filePath + '/admin/basic/',//删除基础配置
	//数据迁移接口
	postSensitiveMigrateAll: filePath + '/school/sensitive/migrate/history/all',//全量迁移学生敏感记录历史
	postSensitiveMigrateSchool: filePath + '/school/sensitive/migrate/history/school',//按校迁移学生敏感记录历史


}
const edu = {
	getUserList: filePath + '/edu/user/list', //jiaz
}
const parent = {
	getUserList: filePath + '/parent/list', //查询教育局
}
const student = {
	// getInfo
	getStudentInfo: filePath + '/student/getInfo', //通过学生id获取信息
	pollTeacherMsg: filePath + '/school/class/student/poll/teacherMsg',//已停止使用，
	getUserList: filePath + '/student/list', //查询中台用户
	postStudentSensitive: filePath + '/sensitive/report', //敏感词上报
	getSensitiveClass: filePath + '/sensitive/stat/class/', //按班级统计全班学生违规次数{schoolId}/{classId}
	getSensitiveClassCourse: filePath + '/sensitive/stat/class-course', //按班级+课堂统计
	getSensitiveCourse: filePath + '/sensitive/stat/course/', //仅按课堂统计{schoolId}/{courseId}
	getSensitiveStudentPage: filePath + '/sensitive/history/page', //按学生查询，课堂ID传入查课堂否则查全部

	postToggleLike: filePath + '/classRoom/file/toggleLike', //学生的点赞/取消
	postUpdateScoreAndCase: filePath + '/classRoom/file/updateScoreAndCase', //学生的点赞/取消
	getFileAiContent: filePath + '/classRoom/file/aiContent/', //学生评价信息
	
	postSaveRecord: filePath + '/student/operate/saveRecord', //学生课堂Html操作记录上报
	
}
const school = {
	//paper-qr
	getGenerateByClass: filePath + '/paper-qr/generate-by-class', //生成班级学生二维码
	getGenerateByUpdateClass: filePath + '/paper-qr/updateClass', //更新班级学生二维码
	getGenerateByUpdateStudent: filePath + '/paper-qr/updateStudent', //更新单学生二维码
	getGenerateBySchool: filePath + '/paper-qr/generate-teacher-by-school', //生成学校二维码有效期3天
	
	getSchoolId: filePath + '/school/get/', //根据学校id查询信息

	postSchoolUserBindPhone: filePath + '/school/user/bindPhone', //绑定手机号码
	
	
	
	//小组
	getGroupStudentList: filePath + '/school/group/student/selectList', //学生是否在小组的接口
	getGroupList: filePath + '/school/group/list', //小组列表
	postGroupCreate: filePath + '/school/group/create', //新增小组
	postGroupUpdate: filePath + '/school/group/update', //修改小组
	deletedGroupId: filePath + '/school/group/delete/', //删除小组

	//标准课程
	getCourseaOrgList: filePath + '/ai/course/orglist', //查询机构下标准课程


	//任职--
	postAssignSave: filePath + '/teacher/assign/save', //添加任职通用
	deletedAssign: filePath + '/teacher/assign/delete/', //	删除任职（自动判断角色）{id}
	getAssignGrade: filePath + '/teacher/assign/grade/', //按年级查所有任教{gradeId}
	getAssignUser: filePath + '/teacher/assign/user/', //按用户查角色 + 班级{userId}
	getAssignClass: filePath + '/teacher/assign/class/', //按班级查所有学科教师{userId}

	getUserRoleList: filePath + '/teacher/assign/user/role/assign/list', //教师{userId}查询任职列表信息缓存机制


	//按学校+学段+角色查询（子管理员/校领导/部门人员）  非普通老师
	getSchoolAdminList: filePath + '/teacher/assign/school/section/role', //根据角色返回
	//按学校+年级查询年级组长
	getSchoolGradeLeaderList: filePath + '/teacher/assign/school/grade/leader', //根据角色返回
	//按学校+学科查询学科组长
	getSubjectList: filePath + '/teacher/assign/school/subject/leader', //根据角色返回
	//按学校+年级+学科查询备课组长
	getSchoolUpdateId: filePath + '/teacher/assign/school/grade/subject/leader/', //根据角色返回{id}


	//用户
	PutSchoolPwd: filePath + '/school/user/updatePwd', //修改用户密码
	PutSchoolText: filePath + '/school/user/update', //修改用户信息
	getSchoolList: filePath + '/school/user/list', //查询学校用户列表
	getUserList: filePath + '/school/user/list', //查询学校用户列表
	getSchoolSearch: filePath + '/school/user/search', //模糊搜索用户
	postSchoolUserAdd: filePath + '/school/user/add', //修改信息
	postSchoolUserBatchAdd: filePath + '/school/user/batchAdd', //批量新增学校用户
	postSchoolPwd: filePath + '/school/user/resetPwd', //重置密码
	postSchoolStatus: filePath + '/school/user/status', //修改状态
	//学校年级
	getSchoolGrad: filePath + '/school/grade/list/normal', //查询学校年级列表
	//学校班级
	getSchoolClass: filePath + '/school/class/list/school', //查询学校所有班级
	getSchoolGradClass: filePath + '/school/class/list/grade', //查询学校指定年级所有班级
	postGradeClass: filePath + '/school/class/batch/create', //单个添加update/name
	postClassName: filePath + '/school/class/update/name', //修改班级名称
	//校区
	getSchoolAreaList: filePath + '/school/area/list', //学校校区列表
	postSchoolAreaAdd: filePath + '/school/area/add', //新增校区
	putSchoolAreaUpdate: filePath + '/school/area/update', //修改校区
	deletedSchoolArea: filePath + '/school/area/', //修改校区
	getSchoolArea: filePath + '/school/area/', //新增校区
	putSchoolAreaChangeStatus: filePath + '/school/area/changeStatus', //修改校区
	

	//学生

	getStudentList: filePath + '/student/listByClassId', //班级学生列表
	postStudentAdd: filePath + '/student/add', //单个添加
	postStudentSaveOrUpdate: filePath + '/student/saveOrUpdate', //更新学生信息
	postStudentImport: filePath + '/student/import', //批量添加

	//课堂交互--教师
	postSchoolClasscreate: filePath + '/school/class/teacher/create', //添加课堂
	postSupplementStudent: filePath + '/school/class/supplement/student', //补发学生
	postEndClass: filePath + '/school/class/teacher/end', //添加课堂

	getTeacherClassList: filePath + '/school/class/teacher/classPage', //教师查询自己的
	postSchoolClasscreateStart: filePath + '/school/class/teacher/start', //添加课堂
	
	getCreateStudentList: filePath + '/school/class/teacher/studentList', //通过课堂id获取学生列表
	postPraiseAdd: filePath + '/studentClass/teacher/praise/add', //新增教师给学生表扬
	postPraiseUpdate: filePath + '/studentClass/teacher/praise/update', //修改教师给学生表扬
	getPraiseStudent: filePath + '/studentClass/teacher/praise/student', //教师给学生表扬列表
	postPraiseStudent: filePath + '/studentClass/teacher/praise/delete', //删除教师给学生表扬
	postCreateWatchTicket: filePath + '/school/class/teacher/createWatchTicket', //观课二维码生成
	getCheckWatchTicket: filePath + '/school/class/teacher/checkWatchTicket', //免密登陆
	saveConversationId: filePath + '/school/class/saveConversationId', //修改对话id
	postUploadCallback: filePath + '/classRoom/file/uploadCallback', //上传批注图片记录数据
	getCallbackList: filePath + '/classRoom/file/list', //上传批注图片记录数据
	getConversationId: filePath + '/school/class/getConversationId', //查询对话id
	//课堂交互--学生
	getStudentClassList: filePath + '/school/class/student/courseList', //学生查询自己的
	postStudentEnter: filePath + '/school/class/student/enter', //学生进入课堂
	postStudentLeave: filePath + '/school/class/student/leave', //离开课堂
	getInfoById: filePath + '/school/class/getInfoById', //查询课堂信息
	getMyStatus: filePath + '/school/class/student/getMyStatus', //查询课堂信息
	postStudentChat: filePath + '/school/class/student/chat', //发送信息通过角色定义
	getWithRoleList: filePath + '/school/class/teacher/chat/withRole', //学生发送信息记录
	getHistoryList: filePath + '/school/class/student/chat/history', //学生发送信息记录
	getTeacherChatNew: filePath + '/school/class/teacher/chat/new', //新的消息
	getTeacherFoStudent: filePath + '/school/class/teacher/chat/all', //教师角色查询学生的所有记录
	//新的mogo逻辑
	postChat: filePath + '/school/studentMessage/chat', //智能体对话/新增上传作品
	postChatUpdate: filePath + '/school/studentMessage/chat/update', //更新评价作品信息
	getLikePage: filePath + '/school/studentMessage/like/page', //分页查询作品
	getLikeCasePage: filePath + '/school/studentMessage/like/case/page', //分页查询优秀案例
	getFirstChatTest: filePath + '/school/studentMessage/getFirstChatTest', //根据作品id返回评价信息
	getTeacherChatPage: filePath + '/school/studentMessage/teacher/chat/page', //教师查询学生消息
	getStudentChatPage: filePath + '/school/studentMessage/student/chat/page', //学生端对话历史分页
	//新点赞接口
	postSaveOrUpdate: filePath + '/workLikeRecord/saveOrUpdate', //更新点赞接口
	getStudentMessageList: filePath + '/school/studentMessage/student/list', //更新点赞接口
	
	
	
	
	
	
	
	
	updateControlStudentPage: filePath + '/school/class/teacher/updateControlStudentPage', //管控学生页面
	cozeStream: filePath + '/sys/school/class/student/coze/stream', //扣子转发

	pushCountDown: filePath + '/school/class/teacher/pushCountDown', //通知学生倒计时的内容
	getCLassroomReport: filePath + '/school/class/teacher/statistics/report', //通知学
	postUpdateClassDisabledMenus: filePath + '/school/class/updateClassDisabledMenus', //禁用的菜单
	//课堂交互双端
	postClassGlobalConfig: filePath + '/school/class/teacher/saveClassGlobalConfig', //同步一次课堂交互字段
	getClassGlobalConfig: filePath + '/school/class/teacher/getClassGlobalConfig', //获取缓存
	//课堂调用模型统一新接口
	postStreamChat: filePath + '/school/class/stream/chat', //同步一次课堂交互新字段传入
	//{"modelId":模型Id,"content":文本图片地址也是这里后端自己判断,"keyId":密钥id,"studentId":学生id字符串,"courseClassId",课堂id}
	
	//基础评语管理
	postPraiseTemplateAdd: filePath + '/teacher/praise/template/add', //增加评语
	postPraiseTemplateUpdate: filePath + '/teacher/praise/template/update', //修改评语
	postPraiseTemplateDelete: filePath + '/teacher/praise/template/delete', //删除评语
	getPraiseTemplateList: filePath + '/teacher/praise/template/list', //评语类别分页
	getPraiseTemplateListAll: filePath + '/teacher/praise/template/listAll', //按照类型查status0的不分页，必须传类型和教师

	postPraiseTemplateStatus: filePath + '/teacher/praise/template/status', //修改评语状态
	//html所有方法
	getlistForPlayback: filePath + '/student/operate/listForPlayback', //查询学生课堂Html操作记录上报
	getHtmlStatByClass: filePath + '/student/operate/statByClass', //课堂html汇总
	getLayerList: filePath + '/student/layer/stat', //分层id查询规则信息

}
const get = function(url, params) {
	return new Promise((resolve, reject) => {
		axios.get(url, {
				params: params,
				// withCredentials: true,
			})
			.then(res => {
				if (res.status >= 200 && res.status < 300) {

					resolve(res);
				} else {
					reject(res);
				}
			}).catch(err => {
				reject(err.data);
			})
	});
}

const getInBody = function(url, params) {
	return new Promise((resolve, reject) => {
		axios
			.get(url, {
				body: params,
			})
			.then(res => {
				if (res.status >= 200 && res.status < 300) {
					if (res.data.code == 401) {
						Message.error(res.data.msg)

					} else {
						resolve(res);
					}

				} else {
					reject(res);
				}
			}).catch(err => {
				reject(err.data);
			})
	});
}
const postFileTypeGet = (url, params) => {
	const loading = Loading.service({
		lock: true,
		text: '加载中...',
		spinner: 'el-icon-loading',
		background: 'rgba(0, 0, 0, 0.7)'
	});

	return axios({
			method: 'post',
			url,
			data: params,
			headers: {
				Accept: 'application/octet-stream',
			},
			responseType: 'blob',
		})
		.then(async (res) => {
			// 判断是否是 JSON 错误信息
			const isJson = res.data.type === 'application/json';

			if (isJson) {
				const errMsg = await res.data.text();
				return Promise.reject(JSON.parse(errMsg));
			}
			loading.close();
			return res;
		})
		.catch((err) => {
			loading.close();
			return Promise.reject(err);
		});
};
const post = function(url, params) {

	return new Promise((resolve, reject) => {
		axios.post(url, params)
			.then(res => {
				if (res.status >= 200 && res.status < 300) {
					resolve(res);
				} else {
					reject(res)
				}
			}).catch(err => {
				reject(err.data)
			})
	});
}

const put = function(url, params) {
	// console.log(...arguments)
	return new Promise((resolve, reject) => {
		axios.put(url, params)
			.then(res => {

				resolve(res);
			}).catch(err => {
				reject(err.data)
			})
	});
}
const putFromData = function(url, params) {
	return new Promise((resolve, reject) => {
		axios({
			method: 'put',
			url,
			data: params,
			transformRequest: [
				function(data) {
					// 将请求数据转换成功 formdata 接收格式
					return stringify(data)
				}
			],
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		}).then(res => {
			if (res.status == "200") {
				resolve(res);
			} else {
				reject(res);
			}
		})
	})

}
const postFromData = function(url, params) {
	return new Promise((resolve, reject) => {
		const formData = new FormData();
		if (params && typeof params === 'object') {
			Object.keys(params).forEach(key => {
				formData.append(key, params[key]);
			});
		}
		axios({
				method: 'post',
				url: url,
				data: formData,
				timeout: 30000,
				responseType: 'json',
				headers: {},
			})
			.then((res) => {
				console.log('监听上传', res)
				let data = res.data || res
				resolve(data);
			})
			.catch((error) => {
				console.log('监听上传失败', error)
				reject(error)
			});
	})
}
const postFromFileData = function(url, params) {
	return new Promise((resolve, reject) => {
		axios({
			method: 'post',
			url,
			data: params,
			// transformRequest: [
			// 	function (data) {
			// 		// 将请求数据转换成功 formdata 接收格式
			// 		console.log(data,'data')
			// 		return stringify(data)
			// 	}
			// ],
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		}).then(res => {
			if (res.status == "200") {
				resolve(res);
			} else {
				reject(res);
			}
		}).catch(() => {
			reject();
		})
	})

}
const deleted = function(url, params) {
	return new Promise((resolve, reject) => {
		axios.delete(url, params)
			.then(res => {
				if (res.status >= 200 && res.status < 300) {
					resolve(res);
				} else {
					reject(res);
				}
			})
	});
}
const getFileTypeGet = function(url, params) {
	const loading = Loading.service({
		lock: true,
		text: 'Loading',
		spinner: 'el-icon-loading',
		background: 'rgba(0, 0, 0, 0.7)'
	});
	return new Promise((resolve, reject) => {
		axios
			.get(url, {
				params: params,
				headers: {
					"Content-Type": "application/json",
					"accept": "application/octet-stream",
				},
				responseType: 'blob',
				responseEncoding: "utf-8"
			})
			.then(res => {
				loading.close();
				if (res.status == "200") {
					resolve(res);
				} else {
					reject(res);
				}
			}).catch(err => {
				reject(err.data);
				loading.close();
			})
	});
}
const getAccaptFile = function(url, params) {

	return new Promise((resolve, reject) => {
		axios.get(url, {
			params: params,
			headers: {
				'content-type': 'application/json;charset=utf-8',
				'Cache-Control': 'no-cache',
				'Accept': 'application/json, text/plain, */*',
			},
			responseType: 'blob',
			responseEncoding: "utf-8"
		}).then(res => {

			if (res.status == "200") {
				resolve(res);
			} else {
				reject(res);
			}
		}).catch(err => {
			reject(err.data);
		})
	});
}
const patch = function(url, params) {
	return new Promise((resolve, reject) => {
		axios
			.patch(
				// 第一个参数：请求 URL（需提前拼接好路径变量，如 /detail/123/pdf-page）
				url,
				// 第二个参数：请求体数据（对应 @RequestBody，你的接口无请求体，传空对象 {} 即可）
				{},
				// 第三个参数：配置项（与原有 get 封装的配置完全一致，params 对应 @RequestParam 查询参数）
				{
					params: params, // 关键：@RequestParam 参数放在这里（自动拼接为 URL 查询参数）
					headers: {
						'content-type': 'application/json;charset=utf-8',
						'Cache-Control': 'no-cache',
						'Accept': 'application/json, text/plain, */*',
					},
					responseType: 'blob', // 复用原有配置，若不需要 blob 可删除
					responseEncoding: "utf-8" // 复用原有配置，按需保留
				}
			)
			.then(res => {
				// 与原有 get 封装一致：判断状态码为字符串 "200" 才 resolve
				if (res.status >= 200 && res.status < 300) {
					resolve(res);
				} else {
					reject(res);
				}
			})
			.catch(err => {
				// 与原有 get 封装一致：reject 传递 err.data
				reject(err.data);
			})
	});
}
const postFromAccaptFile = function(url, params) {
	return new Promise((resolve, reject) => {
		axios({
			method: 'post',
			url,
			data: params,
			transformRequest: [
				function(data) {
					// 将请求数据转换成功 formdata 接收格式
					return stringify(data)
				}
			],
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			responseType: 'blob',
			responseEncoding: "utf-8"
		}).then(res => {
			if (res.status == "200") {
				resolve(res);
			} else {
				reject(res);
			}
		}).catch(err => {
			reject(err.data);
		})
	});
}
// 添加请求拦截器，在请求头中加token
axios.interceptors.request.use(
	config => {
		if (localStorage.getItem('token')) {
			config.headers.Authorization = localStorage.getItem('token');
			config.headers.token = localStorage.getItem('token');
		}
		return config;
	},
	error => {
		return Promise.reject(error);
	});

axios.interceptors.response.use(
	(response) => {
		// ====================== ✅ 核心：接收后端返回的新 token，并更新 ======================
		const newToken = response.headers['token'] || response.headers['Authorization'];
		if (newToken) {
			console.log("自动刷新Token:", newToken);
			localStorage.setItem('token', newToken);
		}

		if (response.status >= 200 && response.status < 300) {

			if (response.data.code == 401) {
				
				if(!isTokenNO){
					isTokenNO=true
					Message.error(response.data.msg);
					setTimeout(()=>{
						isTokenNO=false
					},1000)
				}
				
				let userType = localStorage.getItem('userType')
				// 清理登录信息
				localStorage.clear()
				const base = process.env.BASE_URL
				// 👇 完全按你的退出逻辑跳转
				setTimeout(() => {

					if (userType == 1) {
						window.location.href = base + '#/admin/login'
					} else if (userType == 2) {
						window.location.href = base + '#/login?type=teacher'
					} else if (userType == 3) {
						window.location.href = base + '#/login?type=student'
					} else {
						window.location.href = base + '#/login'
					}
				})

			} else {
				return Promise.resolve(response);
			}

		} else {
			return Promise.reject(response);
		}
	},

	// 服务器状态码不是2开头的的情况
	// 这里可以跟你们的后台开发人员协商好统一的错误状态码
	// 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
	// 下面列举几个常见的操作，其他需求可自行扩展
	error => {
		// 先防止网络错误导致崩溃
		if (!error || !error.response) {
			Message.error("网络异常，请稍后重试");
			return Promise.reject(error);
		}

		const status = error.response.status;

		switch (status) {
			// 401 未登录 → 自动按 userType 跳转
			case 401:

				try {
					
					// 取用户类型
					let userType = localStorage.getItem('userType')
					// 清理登录信息
					localStorage.clear()

					// 👇 完全按你的退出逻辑跳转
					setTimeout(() => {
						const base = process.env.BASE_URL
						if (userType == 1) {
							window.location.href = base + '#/admin/login'
						} else if (userType == 2) {
							window.location.href = base + '#/login?type=teacher'
						} else if (userType == 3) {
							window.location.href = base + '#/login?type=student'
						} else {
							window.location.href = base + '#/login'
						}
					}, 100)
				} catch (e) {
					const base = process.env.BASE_URL
					localStorage.clear()
					window.location.href = base + '#/login'
				}
				break


			case 403:
				Message.error("没有权限");
				break;

			case 404:
				Message.error("请求地址不存在");
				break;

			case 500:
				Message.error("服务器异常");
				break;

			default:
				const msg = error.response.data.message || "请求失败";
				Message.error(msg);
		}

		return Promise.reject(error.response);
	}
);

function stringify(data) {
	const formData = new FormData()
	for (const key in data) {
		// eslint-disable-next-line no-prototype-builtins
		if (data.hasOwnProperty(key)) {
			if (data[key]) {
				if (data[key].constructor === Array) {
					// console.log('arror')
					if (data[key][0]) {
						if (data[key][0].constructor === Object && false) {
							formData.append(key, JSON.stringify(data[key]))
						} else {
							data[key].forEach((item, index) => {
								if (item.constructor === Object) {
									for (let v in item) {
										formData.append(key + `[${index}].${v}`, item[v])
									}
								}


							})
						}
					} else {
						// formData.append(key + '[]', '')
					}
				} else if (data[key].constructor === Object) {
					formData.append(key, JSON.stringify(data[key]))
				} else {
					formData.append(key, data[key])
				}
			} else {
				if (data[key] === 0) {
					formData.append(key, 0)
				} else if (data[key] === undefined) {

				} else {
					formData.append(key, '')
				}
			}
		}
	}
	return formData
}

export default {
	get,
	post,
	fileurl,
	admin,
	school,
	student,
	put,
	deleted,
	patch,
	filePath,
	isVue,
	postFromData,
	putFromData,
	getFileTypeGet,
	getAccaptFile,
	postFromAccaptFile,
	postFromFileData,
	postFileTypeGet,
	edu,
	parent
}
